<template>
  <section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--${vars.backgroundColor})`">
    <div class="container">
      <!-- Üst Büyük Fotoğraf Alanı (UNCHANGED) -->
      <div class="tw-mb-16 tw-text-center">
        <div class="tw-relative tw-mx-auto tw-max-w-6xl">
          <NuxtImg v-if="vars.photoImage" :src="vars.photoImage" class="tw-w-full" />
          <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
            <div v-html="vars.titleHtml" class="tw-flex tw-flex-row tw-flex-wrap" />
          </div>
        </div>
      </div>

      <!-- Timeline Container -->
      <div class="tw-relative tw-mx-auto tw-max-w-6xl">
        <!-- Milestone Kartları -->
        <div class="tw-space-y-16">
          <div
            v-for="(card, index) in cards"
            :key="index"
            class="tw-flex tw-flex-col-reverse tw-items-center tw-gap-8 tw-border-b tw-border-gray-700 tw-py-8 last:tw-border-none md:tw-flex-row"
            :class="card.reverse ? 'md:tw-flex-row-reverse' : ''"
          >
            <!-- Metin Bloku -->
            <div class="tw-w-full tw-text-center md:tw-w-1/2" :class="card.reverse ? 'md:tw-pr-16' : 'md:tw-pl-16'">
              <div class="tw-relative tw-inline-block">
                <div
                  class="-translate-x-1/2 tw-absolute tw-left-1/2 tw-z-0 tw-h-20 tw-w-px tw-transform tw-bg-[#EF787C]"
                  style="top: -6rem"
                ></div>
                <p class="mb-2" :style="`color: var(--c-primary) !important;`">
                  {{ card.year }}
                </p>
              </div>

              <h3 class="tw-mb-4 tw-text-2xl tw-font-bold" :style="{ color: `var(--${vars.textColor})` }">
                {{ card.title }}
              </h3>
              <p class="tw-text-gray-600" :style="{ color: `var(--${vars.textColor})`, opacity: 0.8 }">
                {{ card.description }}
              </p>
            </div>

            <!-- Fotoğraf Bloku (z-index yükseltildi) -->
            <div class="tw-w-full md:tw-w-1/2" :class="card.reverse ? 'md:tw-pl-16' : 'md:tw-pr-16'">
              <div class="tw-relative tw-z-10 tw-mx-auto tw-max-w-md">
                <NuxtImg v-if="card.photo" :src="card.photo" class="tw-w-full" />
                <div
                  v-else
                  class="tw-aspect-video tw-w-full tw-rounded-lg tw-bg-gray-200"
                  :style="{ borderRadius: 'var(--rounded)' }"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Alt Metin (UNCHANGED) -->
        <div v-if="vars.titleText" class="tw-mt-16 tw-text-center">
          <h2 class="tw-mx-auto tw-max-w-2xl" :style="{ color: `var(--${vars.textColor})` }">
            {{ vars.titleText }}
          </h2>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'ContentBoxTheme7',

  mixins: [ComponentMixin],
  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>
